(() => {
  const ROW_SELECTOR = ':scope > tr.cart-item';
  const BODY_SELECTOR = '.japotyle-cart-template .cart-items tbody, #CartDrawer .cart-items tbody';
  const GROUP_TONE_CLASSES = [
    'japotyle-cart-group-tone-1',
    'japotyle-cart-group-tone-2',
    'japotyle-cart-group-tone-3',
    'japotyle-cart-group-tone-4'
  ];

  const normalized = (value) => String(value || '').trim();

  const updateStoreToolsCartCount = (cartData) => {
    const count = Number(cartData?.item_count);
    if (!Number.isFinite(count) || count < 0) return;

    document.querySelectorAll('[data-japotyle-cart-link]').forEach((link) => {
      const badge = link.querySelector('[data-japotyle-cart-count]');
      if (badge) {
        const countText = String(count);
        if (badge.textContent !== countText) badge.textContent = countText;
        if (badge.hidden !== (count === 0)) badge.hidden = count === 0;
      }

      const labelTemplate = link.dataset.cartLabelTemplate || 'Cart (%COUNT%)';
      const label = labelTemplate.replace('%COUNT%', String(count));
      if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    });
  };

  const syncEmptyCartCount = () => {
    const cartItems = document.querySelector('.japotyle-cart-template cart-items');
    if (
      cartItems
      && cartItems.classList.contains('is-empty')
      && !cartItems.querySelector('.cart-item')
    ) {
      updateStoreToolsCartCount({ item_count: 0 });
    }
  };

  const serviceMatchesItem = (service, item) => {
    const linkedVariantId = normalized(service.dataset.japotyleLinkedVariantId);
    const linkedSku = normalized(service.dataset.japotyleLinkedSku);
    const itemVariantId = normalized(item.dataset.japotyleCartVariantId);
    const itemSku = normalized(item.dataset.japotyleCartSku);

    return Boolean(
      (linkedVariantId && linkedVariantId === itemVariantId)
      || (linkedSku && itemSku && linkedSku === itemSku)
    );
  };

  const arrangeBody = (body) => {
    const rows = Array.from(body.querySelectorAll(ROW_SELECTOR));
    if (!rows.length) return;

    rows.forEach((row) => {
      row.classList.remove(
        'japotyle-cart-group-start',
        'japotyle-cart-group-end',
        'japotyle-cart-photo-service',
        'japotyle-cart-photo-service--orphan',
        ...GROUP_TONE_CLASSES
      );
    });

    const products = rows.filter((row) => row.dataset.japotylePhotoService !== 'true');
    const services = rows.filter((row) => row.dataset.japotylePhotoService === 'true');
    const usedServices = new Set();
    const ordered = [];

    products.forEach((product, productIndex) => {
      const toneClass = GROUP_TONE_CLASSES[productIndex % GROUP_TONE_CLASSES.length];
      product.classList.add('japotyle-cart-group-start', toneClass);
      ordered.push(product);

      const linkedServices = services.filter(
        (service) => !usedServices.has(service) && serviceMatchesItem(service, product)
      );

      linkedServices.forEach((service) => {
        usedServices.add(service);
        service.classList.add('japotyle-cart-photo-service', toneClass);
        ordered.push(service);
      });

      (linkedServices.at(-1) || product).classList.add('japotyle-cart-group-end');
    });

    services.forEach((service, serviceIndex) => {
      if (usedServices.has(service)) return;
      const toneClass = GROUP_TONE_CLASSES[(products.length + serviceIndex) % GROUP_TONE_CLASSES.length];
      service.classList.add(
        'japotyle-cart-group-start',
        'japotyle-cart-group-end',
        'japotyle-cart-photo-service',
        'japotyle-cart-photo-service--orphan',
        toneClass
      );
      ordered.push(service);
    });

    if (ordered.some((row, index) => rows[index] !== row)) {
      const fragment = document.createDocumentFragment();
      ordered.forEach((row) => fragment.appendChild(row));
      body.appendChild(fragment);
    }
  };

  const arrangeAll = (root = document) => {
    root.querySelectorAll(BODY_SELECTOR).forEach(arrangeBody);
  };

  const scheduleArrange = (() => {
    let frame = null;
    return () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        arrangeAll();
        syncEmptyCartCount();
      });
    };
  })();

  const start = () => {
    arrangeAll();
    syncEmptyCartCount();
    const observer = new MutationObserver(() => {
      syncEmptyCartCount();
      scheduleArrange();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (
    typeof subscribe === 'function'
    && typeof PUB_SUB_EVENTS !== 'undefined'
    && typeof PUB_SUB_EVENTS.cartUpdate === 'string'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => updateStoreToolsCartCount(event?.cartData));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
